import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const normLocaleModule: LocaleModule = {
  name: "norm",
  messages: { en: en, it: it },
};
